module.exports = __webpack_public_path__ + "img/70.206fc279.jpg";